
function SectionContact() {
    return (
        <div className="section bg-custom-image-contact relative w-full flex flex-col space-y-8 items-start rounded-3xl p-6">
            <h1>لا تتردد في السؤال عن أي شيء.</h1>
            <p className="text-lg">لم تتمكن من العثور على الإجابة التي تبحث عنها؟ يمكنك التواصل مع  فريقنا.</p>
            <a href="https://linktr.ee/fourward.co">
                <button className="bg-white rounded-2xl px-6 py-4 text-lg text-secondary font-bold hover:bg-secondary hover:text-white">تواصل معنا</button>
            </a>
            <svg className="absolute w-20 left-0 ml-8 bottom-0 pb-6
                            lg:left-0 lg:ml-10 lg:w-44" viewBox="0 0 193 193" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_i_4340_6554)">
                    <path d="M57.9167 72.2917H96.25M57.9167 105.833H125M96.25 182.5C143.885 182.5 182.5 143.885 182.5 96.25C182.5 48.6154 143.885 10 96.25 10C48.6154 10 10 48.6154 10 96.25C10 107.723 12.24 118.672 16.3064 128.685C17.0847 130.601 17.4738 131.559 17.6475 132.334C17.8173 133.092 17.8794 133.652 17.8795 134.429C17.8796 135.222 17.7355 136.087 17.4473 137.816L11.7645 171.913C11.1695 175.483 10.8719 177.269 11.4256 178.559C11.9102 179.689 12.8106 180.59 13.9405 181.074C15.2315 181.628 17.0167 181.331 20.5873 180.735L54.6837 175.053C56.4129 174.765 57.2775 174.62 58.0713 174.621C58.8477 174.621 59.4084 174.683 60.1661 174.853C60.9406 175.026 61.8988 175.415 63.8151 176.194C73.8279 180.26 84.7774 182.5 96.25 182.5Z" stroke="white" stroke-width="19.1667" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                    <filter id="filter0_i_4340_6554" x="0.416992" y="0.416626" width="191.666" height="193.667" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="2" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4340_6554" />
                    </filter>
                </defs>
            </svg>

        </div>
    );
}

export default SectionContact;